import React, { useState } from 'react'
import appassets from '../utils/appassets'

const ImageComponent = ({ src, alt, ...props }) => {
  // State to manage the current image source
  const [currentSrc, setCurrentSrc] = useState(src)

  // Handle image loading errors
  const handleError = () => {
    // Set the fallback image when an error occurs
    setCurrentSrc(appassets.dummy)
  }

  return (
    <img
      src={currentSrc}
      alt={alt}
      onError={handleError}
      {...props} // Spread any other props (e.g., className, style)
    />
  )
}

export default ImageComponent
